module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if(isMandatory){

    ; __append("\r\n<svg viewBox=\"0 0 576 512\" class=\"pf-badge mobile-badge mobile-badge-mandatory\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill=\"#ffffff\" d=\"M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z\" class=\"\">\r\n    <title> Mandatory </title>\r\n</path>\r\n</svg>\r\n")
    ; 
}

    ; __append("\r\n")
    ; 
if(isNormal){

    ; __append("\r\n<svg viewBox=\"0 0 576 512\" class=\"pf-badge mobile-badge mobile-badge-normal\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill=\"#ffffff\" d=\"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z\" class=\"\">\r\n        <title> Normal </title>\r\n    </path>\r\n</svg>\r\n")
    ; 
}

    ; __append("\r\n")
    ; 
if(isHidden){

    ; __append("\r\n<svg viewBox=\"0 0 576 512\" class=\"pf-badge mobile-badge mobile-badge-hidden\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill=\"#ffffff\" d=\"M286.693 391.984l32.579 46.542A333.958 333.958 0 0 1 288 440C168.19 440 63.031 376.051 6.646 280.369a47.999 47.999 0 0 1 0-48.739c24.023-40.766 56.913-75.775 96.024-102.537l57.077 81.539C154.736 224.82 152 240.087 152 256c0 74.736 60.135 135.282 134.693 135.984zm282.661-111.615c-31.667 53.737-78.747 97.46-135.175 125.475l.011.015 41.47 59.2c7.6 10.86 4.96 25.82-5.9 33.42l-13.11 9.18c-10.86 7.6-25.82 4.96-33.42-5.9L100.34 46.94c-7.6-10.86-4.96-25.82 5.9-33.42l13.11-9.18c10.86-7.6 25.82-4.96 33.42 5.9l51.038 72.617C230.68 75.776 258.905 72 288 72c119.81 0 224.969 63.949 281.354 159.631a48.002 48.002 0 0 1 0 48.738zM424 256c0-75.174-60.838-136-136-136-17.939 0-35.056 3.473-50.729 9.772l19.299 27.058c25.869-8.171 55.044-6.163 80.4 7.41h-.03c-23.65 0-42.82 19.17-42.82 42.82 0 23.626 19.147 42.82 42.82 42.82 23.65 0 42.82-19.17 42.82-42.82v-.03c18.462 34.49 16.312 77.914-8.25 110.95v.01l19.314 27.061C411.496 321.2 424 290.074 424 256zM262.014 356.727l-77.53-110.757c-5.014 52.387 29.314 98.354 77.53 110.757z\" class=\"\">\r\n        <title> Hidden </title>\r\n    </path>\r\n</svg>\r\n")
    ; 
}

    ; __append("\r\n")
    ; 
if(isDisabled){

    ; __append("\r\n<svg viewBox=\"0 0 576 512\" class=\"pf-badge mobile-badge mobile-badge-disabled\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill=\"#ffffff\" d=\"M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z\" class=\"\">\r\n                <title> Disabled </title>\r\n            </path>\r\n      </svg>\r\n")
    ; 
}

    ; __append("\r\n")
    ; 
if(isReadOnly){

    ; __append("\r\n<svg viewBox=\"0 0 576 512\" style=\"left:4px\" class=\"pf-badge mobile-badge mobile-badge-readonly\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill=\"#ffffff\" d=\"M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z\" class=\"\" >\r\n    <title> Read-Only </title>\r\n</path>\r\n</svg>\r\n")
    ; 
}

  }
  return __output;

}